import { useEffect, useState } from "react";
import CategoryButton from "./CategoryButton";
import UserScoreInfo from "../CommanComponents/UserScoreInfo";
import { categoriesClass3 } from "../constants/title";
import Chapters from "../CommanComponents/Chapters";
import { useSelector } from "react-redux";
import useChooseChapter from "../hooks/useChooseChapter";
function ClassHomeDemo3() {
  const [userName, setUserName] = useState("Öğrenci");
  const [userScore, setUserScore] = useState([]);
  const scoreInfo = useSelector((state) => state.score.value);
  const chapterInfo = useSelector((state) => state.chapterValue.value);
  const currentActiveId = chapterInfo.activeId;
  useEffect(() => {
    const completedChapters = scoreInfo.filter(
      (item) => item.completedChapter === true,
    );
    setUserScore(completedChapters?.length || 0);
  }, [scoreInfo]);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("postUser"));
    if (user) {
      setUserName(user.username);
    }
  }, []);
  const { chooseClass3Chapter, selection, title, activeCategory } =
    useChooseChapter();
  return (
    <div className="flex flex-col xl:flex-row gap-4  min-h-screen">
      {/* Left Sidebar - Category Selection */}
      <div
        className="flex flex-row xl:flex-col w-full xl:w-3/12 bg-white rounded-xl
      shadow-xl p-4 xl:p-6 overflow-x-auto xl:overflow-x-visible"
      >
        <h2
          className="text-lg xl:text-xl font-bold text-center mb-4 xl:mb-6
          bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent hidden xl:block"
          style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
        >
          🚀 Choose Chapters
          <p className="text-center text-sm font-normal">Bölümleri Seç</p>
        </h2>
        <div className="w-full h-1 bg-blue-400 rounded-md mb-4"></div>
        <div className="flex flex-row xl:flex-col gap-2 xl:gap-0 min-w-max xl:min-w-0">
          {categoriesClass3.map((category) => (
            <CategoryButton
              key={category.id}
              icon={category.icon}
              id={category.id}
              nameTr={category.nameTr}
              name={category.name}
              color={category.color}
              onClick={() => {
                chooseClass3Chapter(category.id);
              }}
              isActive={currentActiveId === category.id}
            />
          ))}
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex flex-row gap-2 xl:gap-4 flex-1">
        <div
          className="flex-1 xl:w-6/3 min-h-[600px] xl:min-h-screen rounded-xl overflow-hidden
         shadow-xl bg-white"
        >
          <div className="w-full h-full p-6">
            <Chapters
              selection={selection}
              userScore={userScore}
              title={chapterInfo.title}
            />
          </div>
        </div>
        <div className="hidden [@media(min-width:1200px)]:block  bg-white rounded-xl  xl:w-3/12">
          <UserScoreInfo userName={userName} userScore={userScore} />
        </div>
      </div>
    </div>
  );
}

export default ClassHomeDemo3;
